<template>
    <transition
            class="content-container"
            name="fade"
            mode="out-in"
            >
        <div class='small-12 medium-12 large-12 hd-12 columns content'>
            <dean-section-title content='true' v-if="title">
                <span slot='title'>
                    <span class='avenir-heavy'>{{ title }}</span>
                </span>
                <slot name="title-items"></slot>
            </dean-section-title>
            <dean-notification>

            </dean-notification>
            <div class="row fields">
                <slot name="left"></slot>
                <slot name="right"></slot>
            </div>
        </div>
    </transition>
</template>

<script lang="ts">
    // VUE
    import {
        Vue,
        Component,
        Prop,
    } from 'vue-property-decorator';

    import {
        deanFormRow,
        deanSectionTitle,
        messageIcon,
    } from '@deanone/dean-components';

    import deanInputSelect from '@/components/deanComponents/deanInputSelect.vue';
    import DeanNotification from '@/components/deanComponents/deanNotification.vue';

    @Component({
        components: {
            DeanNotification,
            deanInputSelect,
            deanFormRow,
            deanSectionTitle,
            messageIcon,
        },
    })
    export default class DeanTwoColumnLayout extends Vue {
        public messageIcon: object = messageIcon;

        // Properties
        @Prop({ default: '' }) private title!: string;
    }
</script>

<style lang='scss'>
    @import '~@deanone/dean-components/src/scss/vars';

    .row.fields {
        display: grid;
        grid-template-columns: 50% 50%;

        .dean-section-title {
            grid-column-end: span 2;
        }

        .dean-select {
            padding:0;
            width:100%;
            display: grid;
            grid-template-columns: 50% 50%;
        }

        .dean-select > label {
            padding: 10px 10px 10px 20px;
            color: #2c3e50;
            text-align-last: start;
        }

        .dean-select > * {
            justify-self: stretch;
            max-width:none;
        }

        .dean-select > select {
            margin-left: 10px;
            margin-right: 10px;
        }

        .dean-select > select:after {
            position: absolute;
            top: 23px;
            content: "";
            left: 20px;
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 4px solid #B6B6B6;
            background: #FFF;
        }
    }
    @media #{$medium-down} {
        .row.fields {
            grid-template-columns: 100%;
        }
    }
</style>
